import React, { useContext, useEffect } from "react";
import { css } from "emotion";
import { boxStyles, colors, textSizes } from "../../styles/theme";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { RoleContext } from "../../context/RoleContext";
import users from "../../services/api/users";
import { GlobalContext } from "../../context/GlobalState";

const PermissionsBody = () => {
  const {
    selectedUser,
    setSelectedUser,
    createdInvite,
    setCreatedInvite,
  } = useContext(RoleContext);
  const { currentWorkspace } = useContext(GlobalContext);

  useEffect(() => {
  }, []);

  const updateRole = async (newRole) => {
    if (selectedUser.id) {
      if (newRole === selectedUser.role) {
        return;
      }

      const updatedData = {
        workspaceId: currentWorkspace.id,
        userId: selectedUser.id,
        role: newRole,
      };
      try {
        await users.updateRole(updatedData);
        setSelectedUser({
          ...selectedUser,
          role: newRole,
        });
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        setCreatedInvite({ role: newRole });
        setSelectedUser({ role: newRole });
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <div className={container}>
      <div className="roleBlock" onClick={() => updateRole("admin")}>
        <div className="roleItem">
          <h4>Admin</h4>
          <div className="flexRow">
            <p>
              Can access <span>everything.</span>
            </p>
            {selectedUser.role === "admin" && (
              <FontAwesomeIcon className="icon" icon="check" />
            )}
          </div>
        </div>
      </div>
      <div className="roleBlock" onClick={() => updateRole("member")}>
        <div className="roleItem">
          <h4>Member</h4>
          <div className="flexRow">
            <p>
              No access to{" "}
              <span>Billing, Plans, Invite Users, or Manage Workspace.</span>
            </p>
            {selectedUser.role === "member" && (
              <FontAwesomeIcon className="icon" icon="check" />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PermissionsBody;

const container = css`
  padding: ${boxStyles.standardPadding};

  .roleBlock {
    padding: 20px 0;

    &:nth-child(odd) {
      border: none;
    }

    .flexRow {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    h4 {
      font-size: ${textSizes.subtitle};
      color: ${colors.titleColor};
    }
    .icon {
      padding: 0 0 0 5px;
      font-size: 20px;
      color: ${colors.brandColor};
    }
    p {
      color: ${colors.placeholderText};
      font-size: ${textSizes.intermediate};
      line-height: 24px;

      span {
        font-weight: bold;
      }
    }
  }

  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    box-shadow: ${boxStyles.boxShadow};
    border-radius: ${boxStyles.borderRadius};
    padding: 0;

  .roleBlock {
    width: 100%;

    &:nth-child(odd) {
      border-bottom: solid 1px;
      border-color: ${colors.lineBreak};
    }

    .roleItem {
      padding: 0 20px;
    }
  }
  }
`;
